/* Epic — spec group tabs.

   Follows the APG tabs pattern rather than approximating it: arrow keys move
   between tabs, Home/End jump to the ends, and only the selected tab is in the
   tab order (roving tabindex), so a keyboard user tabs past the whole group in
   one press instead of four.

   Panels start visible and stacked. This script hides the inactive ones, which
   means a failure to load leaves the full table readable rather than leaving
   three quarters of the data switched off with no way to switch it back. */
(function () {
  'use strict';

  function init(root) {
    var sections = (root || document).querySelectorAll('[data-epic-tabs]');

    Array.prototype.forEach.call(sections, function (section) {
      if (section.hasAttribute('data-ready')) return;

      var list   = section.querySelector('[data-tabs-list]');
      var tabs   = list ? Array.prototype.slice.call(list.querySelectorAll('[role="tab"]')) : [];
      var panels = Array.prototype.slice.call(section.querySelectorAll('[data-tabs-panel]'));
      if (!list || tabs.length < 2 || tabs.length !== panels.length) return;  // one group needs no tabs

      section.setAttribute('data-ready', '');
      list.hidden = false;

      /* The per-panel heading is the tab label once tabs exist — keep it for
         screen readers, drop it visually so it is not said twice on screen. */
      panels.forEach(function (p) {
        var h = p.querySelector('[data-tabs-h3]');
        if (h) h.classList.add('visually-hidden');
      });

      function select(i, focus) {
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          panels[j].hidden = !on;
        });
        if (focus) tabs[i].focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i, false); });
        tab.addEventListener('keydown', function (e) {
          var n = tabs.length, next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % n;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + n) % n;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = n - 1;
          if (next === null) return;
          e.preventDefault();
          select(next, true);
        });
      });

      select(0, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
